<template>
  <b-modal
    centered
    hide-header
    hide-footer
    id="project-rules-modal">

    <h1>
      Quinzaine DU JAPON EN OCCITANIE 2024

      <div class="subtitle mt-4">Règlement</div>

    </h1>

    <h2>I- Présentation</h2>

    <p>Considérant le traité de Paix, d'Amitié et de Commerce entre la France et le Japon conclu le 9 octobre 1858,</p>

    <p>Considérant le traité de commerce et de navigation entre la France et le Japon conclu le 4 août 1896 à Paris,</p>

    <p>Considérant les partenariats de l’Occitanie avec les départements de Kyoto et d’Aichi,</p>

    <p>Considérant les nombreux jumelages liant des communes, associations et institutions d’Occitanie et du Japon.</p>

    <p>Comme suite aux partenariats engagés par les acteurs économiques, culturels et éducatifs d’Occitanie avec le Japon, la Région Occitanie, l’association Yujo ainsi que la Fondation Groupe Dépêche en relation avec l’Ambassade du Japon en France et le Consulat Général du Japon à Marseille ont décidé d’organiser la « Quinzaine du Japon en Occitanie ». Cet événement proposé du 10 au 24 novembre 2023 est organisé sur l’ensemble du territoire d’Occitanie.</p>

    <p><strong>Objectifs :</strong> L’objet de l’appel à projets décidé par les organisateurs est de promouvoir les liens unissant Français et Japonais, de faire vivre l’amitié franco-japonaise au plus près des citoyens et du territoire, de mettre à l’honneur les richesses de la région Occitanie et du Japon en proposant des événements dans les domaines culturels, économiques, éducatifs et sportifs dans l’ensemble de la région Occitanie prioritairement. Les projets retenus bénéficieront du label officiel de la manifestation, d’une communication et d’une promotion portée par le Comité d’organisation dans la limite des conditions prévues par le présent règlement.</p>

    <br/>

    <h2>II- Procédure</h2>

    <h3>1- Conditions d'éligibilité</h3>

    <p>Les projets seront présentés par toute personne physique ou morale impliquée dans le lien franco-japonais. Les manifestations devront avoir lieu entre le 10 et le 24 novembre 2023 en Occitanie prioritairement.</p>

    <p>Les projets à durée plus longue ou programmés à d’autres dates de l’année 2023 pourront faire l’objet d’un examen particulier et leur labellisation pourra être envisagée le cas échéant.</p>

    <h3>2- Thématiques éligibles</h3>

    <p>La situation sanitaire que vit le monde depuis 2020 ainsi que ses conséquences sur nos modes de vie, nos relations ont souligné l’importance de la santé, la recherche mais également le rôle essentiel de la culture dans nos sociétés. L’édition 2023 de la Quinzaine du Japon en Occitanie aura donc à cœur de mettre en valeur ces thématiques, les engagements d’acteurs d’Occitanie et du Japon dans des projets communs. La jeunesse, bien que durement impactée par la crise sanitaire et ses effets économiques sera également l’un des thèmes-phares afin de valoriser les initiatives porteuses de nouvelles perspectives.</p>

    <p>Les thèmes prioritaires pour cet appel à projets portent sur :</p>

    <ul>
      <li>Projets culturels franco-japonais de découverte et de valorisation du patrimoine artistique, musical, littéraire, gastronomique, audiovisuel, des arts plastiques, de l’architecture.</li>
      <li>Coopération économique en favorisant l’ouverture au Japon d’entreprises régionales, l’ouverture à la région Occitanie d’entreprises japonaises, les partenariats économiques, les rencontres et les échanges autour des pratiques économiques, agricoles, artisanales, professionnelles des deux pays partenaires.</li>
      <li>Éducation-Recherche : l’apprentissage de la langue du pays partenaire et le partenariat dans différents domaines, en particulier les sciences, la santé mais aussi la culture (art, musique, patrimoine, gastronomie, technique etc.). Ces projets pourront se traduire par des échanges, l’élaboration de projets binationaux entre établissements scolaires et d’enseignement supérieur, les projets communs de recherche ainsi que les échanges universitaires.</li>
      <li>Jeunesse et sports : rencontres et échanges impliquant des ressortissants des deux pays partenaires, notamment autour de pratiques sportives communes aux deux pays ou traditionnelles dans chacun des pays.</li>
      <li>Politique environnementale : initiatives, échanges d’expériences autour des thématiques du développement durable, de l’énergie et de l’environnement (avec la mer comme trait d’union entre le Japon et la région Occitanie).</li>
    </ul>

    <h3>3- Opérations commerciales et sources de financement</h3>

    <p>Les opérations de promotion de services ou produits régionaux d’Occitanie ou du Japon entrant dans le cadre de la Quinzaine du Japon en Occitanie sont éligibles.Les événements à visée exclusivement commerciale pourront bénéficier de la labellisation mais seront soumis à une participation financière de la part de l’opérateur qui sollicite le label. Cette participation forfaitaire versée au profit de l’association Yujo sera évaluée par le comité de labellisation en fonction du chiffre d’affaires et/ou du nombre de salariés de l’entreprise.Les initiateurs de projets devront préciser leurs sources de financement lors du dépôt de la proposition du projet.</p>

    <h3>4- Critères de sélection</h3>

    <p>Dans le cadre de la préparation de cet appel à projets ont été organisés des commissions techniques qui permettent d’identifier des actions pertinentes dans les principales thématiques retenues :</p>

    <ul>
      <li>Commision culturelle</li>
      <li>Commission academique et education</li>
      <li>Commission sportive</li>
      <li>Commission economique</li>
    </ul>

    <p>Seront particulièrement encouragées les initiatives à destination de la jeunesse afin d’impliquer ces publics dans l’animation de l’amitié entre les deux pays et inscrire durablement cette manifestation dans le calendrier de la coopération franco-japonaise.</p>

    <p>Les projets proposés pourront combiner différentes typologies d’actions (sensibilisation, prospection, promotion,…).</p>

    <p>Une attention particulière sera apportée aux actions dont le caractère innovant permet de découvrir de manière originale le pays partenaire ou encore de renouveler les formes de coopération et d’ouvrir de nouvelles perspectives aux échanges franco-japonais.</p>

    <h3>5- Apport de la labellisation</h3>

    <p>Les projets sélectionnés bénéficieront du label officiel de la manifestation qui sera signalé sur l’ensemble des documents de communication.</p>

    <p>L’ensemble des projets labellisés seront répertoriés dans un programme officiel diffusé via les réseaux franco-japonais en Occitanie et au Japon ainsi que sur le site officiel dédié à la Quinzaine du Japon en Occitanie 2023.</p>

    <p>Ils bénéficieront du plan de communication de la Quinzaine du Japon en Occitanie et notamment d'une inscription sur le site Internet officiel de la manifestation accessible à l’adresse suivante : yujo.japonoccitanie.fr</p>

    <h3>6- Dépôt du dossier</h3>

    <p>Les dossiers seront à déposer par voie électronique sur le site Internet de la manifestation, ou à adresser en version papier à l’adresse suivante :</p>

    <p>Quinzaine du Japon en Occitanie
      <br/>Association Yujoc/o KPMG224 rue Carmin31676 Labège</p>

    <p> Date limite de réception des dossiers de candidature : dimanche 15 octobre</p>

    <p>Pour toute demande d’information : yujo.contact@gmail.com</p>

    <h3>7- Procédures de sélection</h3>

    <p>Les projets seront examinés par le comité de sélection qui délibèrera chaque mois sur les projets en fonction de leur caractère original, du respect des critères établis dans le présent règlement.</p>

    <p>Le comité de sélection est composé : </p>

    <ul>
      <li>D’un représentant de la Région Occitanie</li>
      <li>D’un représentant de l’Ambassade du Japon en France</li>
      <li>D’un représentant du Consulat Général du Japon à Marseille couvrant la région Occitanie</li>
      <li>Du Consul Honoraire du Japon présent en Occitanie</li>
      <li>D’un représentant de l’association Yujo</li>
      <li>D’un représentant de la Fondation Groupe Dépêche</li>
      <li>De représentants des comités techniques </li>
    </ul>

    <p>La sélection des dossiers tiendra compte : </p>

    <ul>
      <li>Du public visé par la manifestation</li>
      <li>Du contenu et de la qualité des prestations proposées</li>
      <li>De la mise en valeur du territoire et de la culture du pays partenaire</li>
      <li>De la capacité à porter le projet : ressources humaines et financières du porteur de projet.</li>
    </ul>

    <h3>8- Suivi du dossier </h3>

    <p>Un accusé de réception sera adressé aux porteurs des projets déposés. Les résultats de l’examen par le Comité de sélection seront notifiés par voie électronique au responsable du projet.</p>

    <h3>9- Communication</h3>

    <p>Les actions et les supports de communication, notamment l’aménagement des stands devront porter distinctement les logos des partenaires financiers de la manifestation. Ils figureront sur tous les supports de communication de l'opération. Le Comité de sélection sera associé à la définition des outils de communication.</p>

    <h3>10- Obligations du porteur de projet</h3>

    <p>Le porteur doit informer les destinataires de la manifestation que l’action bénéficie du label.</p>

    <p>Le porteur s’engage à communiquer sur l’action et ses résultats.</p>

    <p>Le porteur doit afficher le label obtenu sur tout document relatif à la manifestation et destiné au public.</p>

  </b-modal>
</template>

<script>

export default {

  name: 'ProjectRulesModal',

}
</script>

<style scoped>

.modal-content {
  font-family: Montserrat-Regular, "Arial", sans-serif;
  font-size: var(--content-font-size);
}

h1 {
  font-family: SourceSerif4-Bold, "Arial", sans-serif;
  font-size: var(--title-level-one-secondary-font-size);
  margin-bottom: 1rem;
}

h1 .subtitle {
  font-family: SourceSerif4-Regular, "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  margin-bottom: 1rem;
}

h2 {
  font-family: Montserrat-Bold, "Arial", sans-serif;
  color: var(--main-color);
  font-size: var(--title-level-three-font-size);
  margin-bottom: 1rem;
}

h3 {
  font-family: Montserrat-Bold, "Arial", sans-serif;
  font-size: var(--title-level-three-font-size);
  margin-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/views/project/components/ProjectRulesModal.vue